import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useLang } from "@/lib/i18n";
import { useExplore } from "@/lib/ExploreContext";

// Five clean, functional chapters. Each "See all" action goes to real
// category results or the corresponding destination; no dead-end buttons.
const CHAPTERS = {
  culture: { number: "01", en: "CULTURE.", es: "CULTURA.", category: "Culture" },
  day: { number: "02", en: "MORE TO DO.", es: "EXPERIENCIAS.", category: "Experiences" },
  food: { number: "03", en: "EAT & SHOP.", es: "COME Y COMPRA.", category: "Gastronomy" },
  night: { number: "04", en: "AFTER DARK.", es: "DE NOCHE.", category: "Nightlife" },
  more: { number: "05", en: "EXPLORE MORE.", es: "EXPLORA MÁS.", to: "/events" },
};

export default function HomeChapterBreak({ chapter }) {
  const { lang } = useLang();
  const { setActiveChip, setFilterSubs } = useExplore();
  const item = CHAPTERS[chapter];
  if (!item) return null;
  const actionLabel = lang === "es" ? "VER TODOS" : "SEE ALL";
  const label = (
    <>
      <span className="hidden sm:inline">{actionLabel}</span>
      <ArrowUpRight aria-hidden="true" className="h-4 w-4 shrink-0" />
    </>
  );
  const viewCategory = () => {
    setFilterSubs?.(new Set());
    setActiveChip?.(item.category);
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <section id={`home-${chapter}`} aria-label={lang === "es" ? item.es : item.en}
      className="mx-auto mt-11 scroll-mt-[124px] max-w-[1240px] px-4 sm:mt-16 sm:px-6 lg:px-8">
      <div className="flex min-w-0 items-center justify-between gap-2 border-t-2 border-[#171717] pt-3.5 dark:border-[#f7f4ec] sm:gap-4 sm:pt-4">
        <div className="flex min-w-0 items-center gap-2.5 sm:gap-4">
          <span className="shrink-0 font-mono text-[10px] font-extrabold tracking-[.03em] text-[#9e4738] dark:text-[#ff867b]">{item.number} /</span>
          <h2 className="min-w-0 whitespace-nowrap text-[clamp(20px,4.6vw,40px)] font-black uppercase leading-none tracking-[-.06em] text-[#171717] dark:text-[#f7f4ec]">
            {lang === "es" ? item.es : item.en}
          </h2>
        </div>
        {item.to
          ? <Link to={item.to} aria-label={`${actionLabel}: ${lang === "es" ? item.es : item.en}`} className="inline-flex min-h-9 shrink-0 items-center gap-1 text-[10px] font-black tracking-[.04em] hover:text-[#b63830] dark:text-white">{label}</Link>
          : <button type="button" onClick={viewCategory} aria-label={`${actionLabel}: ${lang === "es" ? item.es : item.en}`} className="inline-flex min-h-9 shrink-0 items-center gap-1 text-[10px] font-black tracking-[.04em] hover:text-[#b63830] dark:text-white">{label}</button>}
      </div>
    </section>
  );
}
